import React from 'react';

export default function ForeignSchoolModalContent() {
  return (
    <>
      <p>
        A postsecondary institution not owned by, affiliated with, or funded by
        United States entities and located outside of the United States and US
        Territories.
      </p>
    </>
  );
}
